import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { AccessResponse, SelectLogo } from 'src/app/personal-info/models/personal-info.model';
import { CommonService } from 'src/app/shared-resources/services/common.service';
import { HttpHandlerService } from 'src/app/shared-resources/services/http-handler.service';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';


@Injectable({
  providedIn: 'root'
})
export class TeamWebsiteService {


  constructor(
    private urlMapService: UrlMapService,
    private httpClient: HttpClient,
    private https: HttpHandlerService,
    private commonService: CommonService
  ) { }

  /** get Team Role info */
  getTeamRole(agentNumber: number) {
    const url = this.urlMapService.getTeamRoles() + agentNumber;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get team member info */
  getTeamMemInfo(teamId: number) {
    const url = this.urlMapService.getTeamMemberInfo() + teamId + '/members-info';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);

  }

  /** get team MLS id's */
  getTeamMlsInfo(teamId: number) {
    const url = this.urlMapService.getTeamMemberInfo() + teamId + '/mls';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);

  }

  /** get team logos from db */
  public getLogos(teamId: number): Observable<SelectLogo> {
    let url = this.urlMapService.getTeamMemberInfo() + teamId + '/logos';
    return this.httpClient.get<SelectLogo>(url);
  }

  /** save team default logo */
  saveDefaultLogo(teamId: number, agentNumber: any, id: number): Observable<AccessResponse> {
    const url = this.urlMapService.getTeamMemberInfo() + 'logos?' + 'teamId=' + teamId + '&logoId=' + id + '&agentNumber=' + agentNumber.toString();
    return this.httpClient.post<AccessResponse>(url, null);
  }

  /** get team Specialties */
  getTeamSpeciatiesInfo(teamId: number) {
    const url = this.urlMapService.getTeamSpecialties() + teamId + '/designation-speciality-language';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get team Biography */
  getTeamBio(teamId: number): Observable<string> {
    const url = this.urlMapService.getTeamBio() + teamId + '/biography';
    return this.httpClient.get<string>(url);
  }

  /** save team Biography */
  saveTeamBio(useEmailAddress: string, data: any): Observable<AccessResponse> {
    const url = this.urlMapService.saveTeamBio() + 'useEmailAddress=' + useEmailAddress;
    return this.httpClient.post<AccessResponse>(url, data);
  }

  /** get team photos api method */
  getTeamPhotos(id: any) {
    const url = this.urlMapService.getTeamPhotosUrl() + id + '/photos';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** change team selection */
  changeTeamSelection(id: any, photoId: any) {
    const url = this.urlMapService.changeTeamSelectedUrl() + 'teamId='
      + id + '&photoId=' + photoId;
    return this.https.post(url);
  }

  /** delete picture method here */
  deleteTeamPicture(reqArr: any[], id: any) {
    const opts = { body: reqArr };
    const url = this.urlMapService.teamContactInfoBaseUrl() + id + '/delete-photos';
    return this.https.delete(url, opts);
  }

  /** get contact info api method */
  getTeamContactInfo(agentNumber: string): Observable<any> {
    const url = this.urlMapService.teamContactInfoBaseUrl() + agentNumber + '/contact-info';
    return this.httpClient.get<any>(url);
  }


  /** upload  team agent Images */
  uploadTeamAgentPhotos(reqObj: any, id: any) {
    const url = this.urlMapService.uploadTeamAgentPhotosUrl() + 'teamId=' + id;
    return this.https.post(url, reqObj);
  }

  getTeamCountiesCitiesInfo(teamId: number) {
    const url = this.urlMapService.getTeamSpecialties() + teamId + '/counties-cities-served';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** Toget team website account info */
  getTeamWebsiteAccount(teamId: any, agentNumber: any){
    const url = this.urlMapService.getTeamWebsiteInfo() +teamId + '?agentNumber=' + agentNumber;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** To check for  duplicate URL  */
  duplicateCheckUrl(terms$: Observable<string>, teamId: any): Observable<any>  {
    return terms$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) => from(this.checkDuplicateUrl(term, teamId)))
    )
  }

    /** get URL list and check for URL*/
    checkDuplicateUrl(urlcheck: string, teamId: any) {
      const url = this.urlMapService.getWebsiteAccountInfo() + this.commonService.getAgentNumber() + '/check-url-exists?urlType=Vanity&url=' + urlcheck + '&teamId=' + teamId;
      return this.https.get(url);
    }

    /** API to save websiteAccount data */
  publishWebsite(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.getTeamWebsiteInfo();
    return this.httpClient.post<AccessResponse>(url, data);
  }
  /** get social network affillation */
  getTeamSocialNetworkAffillation(teamId: number) {
    const url = this.urlMapService.getTeamMemberInfo() + teamId + '/social-networks';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

    
  /** save team social network */
  saveTeamSocialNetworkAffillation(reqObj: any) {
    const url = this.urlMapService.saveTeamSocilNetwork();
    return this.https.post(url, reqObj);
  }

  /** get team member publish url api method */
  getTeamMemberWebsiteUrl(teamId : number, agentNumber: string): Observable<any> {
    const url = this.urlMapService.getTeamMemberWebsiteUrl() + teamId + '/member/' + agentNumber;
    return this.httpClient.get<any>(url);
  }

   /** save team social network */
   savePrimaryWebsiteForTeamMember(teamId : number, agentNumber: string,isPrimarySite:boolean){
    const url = this.urlMapService.savePrimaryWebsiteUrl() + teamId + '/member/'+  agentNumber + '?isPrimarySite=' + isPrimarySite;
    return this.https.post(url);
  }

  /** save team social network */
  saveTeamName(teamId : number,){
    const url = this.urlMapService.saveTeamName() + teamId;
    return this.https.post(url);
  }

  getAssistantInfo(teamId: number) {
    const url = this.urlMapService.getTeamMemberInfo() + 'assistant?teamId=' + teamId;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);

  }
  getTeamAssistantData(teamId: number) {
    const url = this.urlMapService.getTeamMemberInfo() + 'team-assistant?teamId=' + teamId;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);

  }
  saveTeamAssistant(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.getTeamMemberInfo() + 'team-assistant/assignment';
    return this.httpClient.post<AccessResponse>(url, data);
  }
}
